import React, { useState, useEffect, useContext, useMemo } from "react"; //FB 4959  EMR-335
import Typography from "@material-ui/core/Typography";
import { Grid, Button, makeStyles, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, CircularProgress } from "@material-ui/core"; //FB 9964
import { useHistory } from "react-router-dom";
//FB 6109
//FB-6264
import { ConfirmAppt, ConfirmParkinglot, LinkExpiry, GetSchedulingPhone, GetPatientContactInfo, GetPatientTypeByApptID, InsertPELogs, GetPatientN, GetAppointmentType, GetAdminSettingValue } from '../appointments/create/api';    //FB 4941	//FB 4959 //FB 4960
import OTPModal from "../appointments/create/components/OTPModal";
import CloseIcon from "@material-ui/icons/Close";
import Styles from "../appointments/create/css/styles";
import globalsettings from "../config";
import { Context } from "../appointments/create/store"; //FB 4959


//Update log
// FB 4867 DK   12/27/2021    Added for the File and Health forms upload feature
// FB 4941 DK   02/07/2022    Logic to Enable/Disable parkinglot
// FB 4959 MS   03/01/2022    Added condition to hide PI button for existing patients in landing page
// FB 4960 BR   07/03/2022    Logging all actions on PE
// FB 6109 DK   08/24/2022    Consent form integration changes
// FB 6158 GS   09/19/2022    Added fix to hide the button displayed when admin parameter "LandingPageFeatures" has no value
// FB 6264 DK   11/22/2022    Migrate PE API,DB to EMR
// FB 6950 KK   06/08/2023    Admin setting to enable/disable Intake or File upload or both
// FB 8088 SK   01/30/2024    Make the PE Confirm Appointment Landing Page Text Customizable
// FB 9964 KI   01/22/2025    Portal - health forms and document upload are unavailable
// FB 10675 DK  06/10/2025    Landing page not working properly; Please identify yourself page should display before buttons
// EMR-185  BH  02/23/2026    disable auto confirmation when the patient clicks landing page URL ?
// EMR-335  DK  04/24/2026    PE- Landing page features are not working as expected

//EMR-335 - Start
function resolveLandingRouteParams(params: any): { decodedApptN: string; licenseName: string; flag: string } {
    const apptType = (params.apptType as string) ?? "";
    const apptId = (params.apptId as string) ?? "";
    const licenseName = (params.licenseName as string) ?? "";
    const flag = (params.flag as string) ?? "";

    const tryDecodeToNumericApptId = (segment: string): string | null => {
        if (!segment) return null;
        const trimmed = segment.trim();
        if (/^\d+$/.test(trimmed)) {
            return trimmed;
        }
        try {
            const decoded = Buffer.from(trimmed, "base64").toString("utf8").trim();
            if (/^\d+$/.test(decoded)) {
                return decoded;
            }
        } catch {
            /* ignore */
        }
        return null;
    };

    if (apptType) {
        const decodedFromType = tryDecodeToNumericApptId(apptType);
        const decodedFromApptId = tryDecodeToNumericApptId(apptId);
        if (decodedFromType !== null && decodedFromApptId === null) {
            const mergedLicense = [apptId, licenseName].filter((s) => s.length > 0).join("/");
            return { decodedApptN: decodedFromType, licenseName: mergedLicense, flag };
        }
    }

    const fromApptId = tryDecodeToNumericApptId(apptId);
    if (fromApptId !== null) {
        return { decodedApptN: fromApptId, licenseName, flag };
    }

    const fromLicenseName = tryDecodeToNumericApptId(licenseName);
    if (fromLicenseName !== null) {
        return {
            decodedApptN: fromLicenseName,
            licenseName: flag,
            flag: /^[01]$/.test(flag.trim()) ? flag : "1",
        };
    }

    let fallbackDecoded = "";
    try {
        fallbackDecoded = Buffer.from(apptId, "base64").toString("utf8").trim();
    } catch {
        fallbackDecoded = "";
    }
    return {
        decodedApptN: /^\d+$/.test(fallbackDecoded) ? fallbackDecoded : "",
        licenseName,
        flag,
    };
}
// EMR-335 End

const Landingpage = (props: any) => {
    const useStyles = makeStyles({
        buttonActive: {
            backgroundColor: "#B9E3E9",
            color: "black",
            textTransform: "capitalize",
            borderRadius: "15px",
            pointerEvents: "none",
            width: "350px",
            height: "40px"
        },
        buttonInactive: {
            backgroundColor: "white",
            color: "#18a2b8",
            textTransform: "capitalize",
            borderRadius: "15px",
            width: "350px",
            height: "40px"
        },
        buttonDone: {
            backgroundColor: "#18a2b8",
            color: "white",
            textTransform: "capitalize",
            borderRadius: "15px",
            marginLeft: "20px",
            fontWeight: "bold",
            "&:hover": {
                backgroundColor: "#18a2b8",
            }
        },
    })

    const { state } = useContext(Context); //FB 4959 
    const [confirmAppt, setConfirmAppt] = useState("");
    const [apptInstructions, setApptinstrunction] = useState(""); //FB 8088
    const [confirmParkingLot, setConfirmParkingLot] = useState("");
    const [patientIntake, setPatientIntake] = useState("");
    const [uploadFiles, setUploadFiles] = useState("none");
    const classes = useStyles();
    const styles = Styles();
    const history = useHistory();
    const [returnValue, setReturnValue] = useState("");
    const [displayMessage, setDisplayMessage] = useState("");
    const [parkingLotMessage, setParkingLotMessage] = useState("");
    const [fontColor, setFontColor] = useState("limegreen");
    const [assisstanceMessage, setAssisstanceMessage] = useState("");
    const [pastMessage, setPastMessage] = useState("none");
    const [buttonsDisplay, setButtonsDisplay] = useState("initial");
    const [displayPastMessage, setDisplayPastMessage] = useState("");
    const [showPLMButton, setShowPLMButton] = useState<boolean>(false);  //FB 4941
    const [displayCancelledMessage, setDisplayCancelledMessage] = useState("");
    const [cancelledMessage, setCancelledMessage] = useState("none");
    const [confirmationMessage, setConfirmationMessage] = useState("");
    const [showConfirmButton, setShowConfirmButton] = useState("flex");
    const [openDialog, setOpenDialog] = useState<boolean>(false);
    const [selectedStep, setSelectedStep] = useState("");
    const [isIntakeAndUploadEnabled, setIsIntakeAndUploadEnabled] = useState<Number | null>(null); // 9964   //FB 6950 
    const [isParkingLotEnabled, setIsParkingLotEnabled] = useState<boolean>(true);  //FB 4941
    const [patientContact, setPatientContact] = useState("");
    const [patN, setPatN] = React.useState(""); //FB 4960
    //FB 6109 Start
    const [appt_type, setAppt_type] = useState("In-Office");
    const [features, setFeatures] = useState([]);
    const [IsPatientVerified, setIsPatientVerified] = useState("");     //FB 10675

    //EMR-335 - Start
    const route = useMemo(() => resolveLandingRouteParams(props.match.params), [
        props.match.params.apptType,
        props.match.params.apptId,
        props.match.params.licenseName,
        props.match.params.flag,
    ]);

    async function GetApptType() {
        if (!route.decodedApptN) {
            return;
        }
        const appt_type = await GetAppointmentType(route.decodedApptN);
        setAppt_type(appt_type[0]);
    }
    //EMR-335 - End

    async function GetFeatures() {
        const data = await GetAdminSettingValue("LandingPageFeatures");
        if (data != null && data != "") { //FB 6158
            setFeatures(data.split(";"));
        }
        //FB 8088 - Begin
        const adminData = await GetAdminSettingValue("PE_Post_Appt_Instructions");
        if (adminData != null && adminData != "") {
            setApptinstrunction(adminData);
        }
        //FB 8088 - End
    }

    useEffect(() => {
        //FB 10675
        const isVerified = sessionStorage.getItem("IsPatientVerified");
        if (isVerified !== null) {
            setIsPatientVerified(isVerified);
        }

        GetFlag();
        GetPatient_N(); //FB 4960
        GetApptType();
        GetFeatures();
    }, [route.decodedApptN, route.licenseName, route.flag]);    //FB 4810   //EMR-335

    //FB 6109 End

    //FB 4960   //EMR-335
    async function GetPatient_N() {
        if (!route.decodedApptN) {
            return;
        }
        const pat_n = await GetPatientN(route.decodedApptN);
        setPatN(pat_n);
    }

    //FB 4941 DK - Start
    async function GetFlag() {
        //FB-6264
        let response = await GetAdminSettingValue("Enable_PatientIntake_And_FileUpload_on_PE");
        if (response.length != 0) {
            //FB 6950 KK
            setIsIntakeAndUploadEnabled(Number(response));
            //FB-6264
            // if (response == 1) {
            //     setIsIntakeAndUploadEnabled(true);
            // }
            // else {
            //     setIsIntakeAndUploadEnabled(false);
            // }
        }
        //FB-6264
        let result = await GetAdminSettingValue("Enable_Parking_Lot_Management");
        if (result.length != 0) {
            //FB-6264
            if (result == 1) {
                setIsParkingLotEnabled(true);
            }
            else {
                setIsParkingLotEnabled(false);
            }
        }
        onload();
    }
    //FB 4941 DK - End

    //EMR-335 - Start
    const onload = async () => {
        //FB 10675
        if (!route.decodedApptN) {
            return;
        }
        //FB 4959 MS BEGIN
        const ptTypeData = await GetPatientTypeByApptID(Number(route.decodedApptN));
        if (ptTypeData == 1)
            state.patient.patient_type = "existing";
        //FB 4959 MS END    
        const linkExpiryReturnData = await LinkExpiry(route.decodedApptN, route.licenseName);
        if (route.flag === "0") {
            setShowConfirmButton("none");
            setShowPLMButton(false);  //FB 4941
        }
        if (route.flag === "1") {
            //EMR-185 Begin � auto-confirm only when admin enables it and patient identity is verified (e.g. OTP / confirmation flow wrote session).
            const defaultAppointConfirm = await GetAdminSettingValue("DefaultAppointmentConfirmation");
            let data = "";
            //EMR-306 Begin- to confirm the appointment only when the patient is verified
            const patientVerified = sessionStorage.getItem("IsPatientVerified") === "Yes";
            if (defaultAppointConfirm == "1" && patientVerified) {
                //EMR-306 End
                data = await ConfirmAppt(Number(route.decodedApptN), route.licenseName);
            }
            //EMR-185 End

            if (linkExpiryReturnData == "Appointment is today") {
                if (route.flag === "1") {
                    setShowPLMButton(true);  //FB 4941
                }
                if (data == "Appointment is confirmed") {
                    setConfirmationMessage("Your appointment is confirmed")
                }
            }
            if (linkExpiryReturnData == "Appointment is in the present or future date") {
                setShowPLMButton(false);  //FB 4941
                if (data == "Appointment is confirmed") {
                    setConfirmationMessage("Your appointment is confirmed")
                }
            }
        }
        const SchedulingPhoneReturnData = await GetSchedulingPhone(route.decodedApptN, route.licenseName);
        //EMR-335  End
        var cleaned = ('' + SchedulingPhoneReturnData).replace(/\D/g, '');
        var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
        var phone = "";
        if (match) {
            phone = '(' + match[1] + ') ' + match[2] + '-' + match[3];
        }

        if (linkExpiryReturnData == "Appointment is in the past") {
            setPastMessage("flex");
            setButtonsDisplay("none")
            setDisplayPastMessage("The link you clicked on, is for the appointment that is already occured.");
            setAssisstanceMessage("For further assistance please call :" + phone);
            setFontColor("black");
        }
        if (linkExpiryReturnData == "Appointment is cancelled") {
            setCancelledMessage("flex");
            setButtonsDisplay("none")
            setDisplayCancelledMessage("The link you clicked on, is for the appointment that is already cancelled.");
            setAssisstanceMessage("For further assistance please call :" + phone);
            setFontColor("black");
        }
    }

    const confirmApptClick = async (selected: string) => {
        setConfirmAppt(selected);
        const data = await ConfirmAppt(Number(route.decodedApptN), route.licenseName);  //EMR-335
        setReturnValue(data);
        if (data == "Appointment is confirmed") { // FB 4831
            setDisplayMessage("Confirmed");
            setFontColor("limegreen");
        }
    }

    const confirmParkinglotClick = async (selected: string) => {
        //FB 4960 Start
        InsertPELogs(globalsettings.clientIp, "Clicked on Check-in from office parking lot for patient" + patN + "  - Landing Page");
        //FB 4960 End
        setConfirmParkingLot(selected);
        const data = await ConfirmParkinglot(route.decodedApptN, route.licenseName);    //EMR-335
        setReturnValue(data);
        if (data == "Patient Arrival is confirmed") { // FB 4831
            setParkingLotMessage("Our office will be notified of your arrival");
            setFontColor("limegreen");
        }
    }

    const patientIntakeClick = async () => {
        //FB 10675
        var encodedAppt_n = Buffer.from(route.decodedApptN).toString('base64'); //EMR-335   
        setSelectedStep("HealthForms");
        if (route.flag === "0") {
            if (IsPatientVerified === "Yes") {
                const IntakeURL = globalsettings.emrAPI + "patient_intake/note_add_edit.asp?app_n=" + encodedAppt_n;
                window.open(IntakeURL);
            }
            else {
                const data = await GetPatientContactInfo(Number(route.decodedApptN));//EMR-335
                if (data.length > 0) {
                    setPatientContact(data[0]);
                    setOpenDialog(true);
                }
            }
        }
        else {
            if (IsPatientVerified === "Yes") {
                var encodedAppt_n = Buffer.from(route.decodedApptN).toString('base64');
                const IntakeURL = globalsettings.emrAPI + "patient_intake/note_add_edit.asp?app_n=" + encodedAppt_n;
                window.open(IntakeURL);
            }
            else {
                history.push("/VerifyPatient/" + encodedAppt_n, { selectedStep: "HealthForms" });
            }
        }
        //FB 4960 Start
        InsertPELogs(globalsettings.clientIp, "Clicked on Patient Intake for patient " + patN + "- Landing page");
        //FB 4960 End
    }

    const uploadFilesClick = async () => {
        setSelectedStep("FileUpload");
        //FB 4960 Start
        InsertPELogs(globalsettings.clientIp, "Clicked on Upload clinical/demographic documents " + patN + " - Landing Page");
        //FB 4960 End
        //FB 10675  //EMR-335
        var encodedAppt_n = Buffer.from(route.decodedApptN).toString('base64');
        if (route.flag === "0") {
            if (IsPatientVerified === "Yes") {
                const Uploadurl = window.location.origin + "/upload/" + encodedAppt_n;
                window.open(Uploadurl);
            }
            else {
                const data = await GetPatientContactInfo(Number(route.decodedApptN));   //EMR-335
                if (data.length > 0) {
                    setPatientContact(data[0]);
                    setOpenDialog(true);
                }
            }
        } else {
            if (IsPatientVerified === "Yes") {
                const Uploadurl = window.location.origin + "/upload/" + encodedAppt_n;
                window.open(Uploadurl);
            }
            else {
                history.push("/VerifyPatient/" + encodedAppt_n, { selectedStep: "FileUpload" });
            }
        }
    }

    //FB 6109
    function GotoFeature(feature: string) {
        var encodedAppt_n = Buffer.from(route.decodedApptN).toString('base64');
        const IntakeURL = globalsettings.emrAPI + "patient_intake/note_add_edit.asp?app_n=" + encodedAppt_n + "&template=" + feature;
        window.open(IntakeURL);
    }

    const handleDone = () => {
        //FB 4960 Start
        InsertPELogs(globalsettings.clientIp, "Clicked on Done - Landing Page");
        //FB 4960 End
        history.replace("/closure", { origin: "landingPage" });
    }

    //FB 4960
    const CloseDialog = () => {
        setOpenDialog(false);
        InsertPELogs(globalsettings.clientIp, "Clicked on Close");
    }

    return (
        <div>
            <section
                style={{
                    margin: "10px 20px 20px",
                }}
            >
                <Grid
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    style={{
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "2%",
                        display: pastMessage
                    }}
                >
                    {/* <Box component="fieldset" mb={12} style={{display: "flex", alignItems: "center",justifyContent:"center"}} borderColor="transparent"> */}
                    <Typography variant="h5" style={{ color: fontColor }} component="legend">
                        <br></br>
                        {displayPastMessage}
                    </Typography>
                    {/* </Box> */}
                </Grid>
                <Grid
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    style={{
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "2%",
                        display: pastMessage
                    }}
                >
                    <Typography variant="h5" style={{ color: fontColor }} component="legend">
                        <br></br>
                        {assisstanceMessage}
                    </Typography>
                </Grid>
                <Grid
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    style={{
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "2%",
                        display: cancelledMessage
                    }}
                >

                    <Typography variant="h5" style={{ color: fontColor }} component="legend">
                        <br></br>
                        {displayCancelledMessage}
                    </Typography>
                </Grid>
                <Grid
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    style={{
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "2%",
                        display: cancelledMessage
                    }}
                >
                    <Typography variant="h5" style={{ color: fontColor }} component="legend">
                        {assisstanceMessage}
                    </Typography>
                </Grid>
                {/* FB 10675 Start */}
                {IsPatientVerified != "Yes" ? (<Grid container style={{ margin: "2rem", alignItems: "center" }}>
                    <Grid
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                    >
                        <Typography style={{ fontSize: "1.1rem" }}>
                            Kindly confirm your identity before continuing with the clinical and demographic documentation
                        </Typography>
                    </Grid>
                    <Grid
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        style={{ paddingTop: "5px" }}
                    >
                        {/* EMR-335 */ }
                        <Button
                            onClick={() => history.push("/VerifyPatient/" + Buffer.from(route.decodedApptN).toString('base64'))}
                            variant="contained"
                            className={styles.navigationButton}
                            id="done"
                        >
                            Verify
                        </Button>
                    </Grid>
                </Grid>) : (<div style={{ display: buttonsDisplay }}>
                    <Grid
                        item
                        xs={12}
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            margin: "2%",
                        }}
                    >
                        {/*FB 4574 DK - Removed uneccesary syntax*/}
                        {/*FB 8088*/}
                        {/*FB 9964 added loader*/}
                        <Typography style={{ fontSize: "1.1rem" }}>
                            {isIntakeAndUploadEnabled === null
                                ? <CircularProgress color="inherit" size={20} />
                                : isIntakeAndUploadEnabled === 0
                                    ? "Patient health forms and Document upload features are temporarily disabled. Apologies for the inconvenience."
                                    : apptInstructions}
                        </Typography>

                    </Grid>
                    <br />
                    {/* FB 10675 Removed unused code */}
                    <Grid container style={{ display: showConfirmButton, justifyContent: "center", alignContent: "center" }}>
                        <Typography style={{ color: fontColor, fontFamily: "bold", fontSize: "18px" }}>
                            {confirmationMessage}
                        </Typography>
                    </Grid>
                    <br />
                    {/* FB 4959 MS BEGIN */}
                    {/* FB 6950 KK --included patient intake condition */}
                    {/* FB 10675 */}
                    {state.patient.patient_type != "existing" || IsPatientVerified == "Yes" ? (
                        <Grid container
                            style={{ display: (isIntakeAndUploadEnabled == 1 || isIntakeAndUploadEnabled == 2) ? "flex" : "none", justifyContent: "center", alignContent: "center" }}
                        >
                            <Button
                                variant="outlined"
                                onClick={() => patientIntakeClick()}
                                className={classes.buttonInactive}
                            >
                                Complete Health Forms
                            </Button>
                        </Grid>
                    ) : (<></>)}
                    {/* FB 4959 MS END */}
                    {/* FB 6950 KK --included file upload condition */}
                    <br />
                    <Grid container
                        style={{ display: (isIntakeAndUploadEnabled == 1 || isIntakeAndUploadEnabled == 3) ? "flex" : "none", justifyContent: "center", alignContent: "center" }}
                    >
                        <Button
                            variant="outlined"
                            onClick={() => uploadFilesClick()}
                            className={classes.buttonInactive}
                        >
                            Upload clinical/demographic documents
                        </Button>
                    </Grid>
                    <br />

                    {/* FB 6109 */}
                    {features.length > 0 ? (features.map((feature: string) => ( //FB 6158
                        <>
                            <Grid container
                                style={{ display: "flex", justifyContent: "center", alignContent: "center" }}>
                                <Button
                                    variant="outlined"
                                    onClick={() => GotoFeature(feature.split(":")[1])}
                                    className={classes.buttonInactive}
                                    style={{ display: feature.toLowerCase().includes("tele") ? (appt_type.toLowerCase().includes("tele") ? "flex" : "none") : "flex" }}
                                >
                                    {feature.split(":")[0]}
                                </Button>
                            </Grid>
                            <br />
                        </>
                    ))) : <></>}  {/*FB 6158 */}

                    {/* FB 4941 */}
                    <Grid container
                        style={{
                            justifyContent: "center", alignContent: "center",
                            display: showPLMButton && isParkingLotEnabled ? "flex" : "none"
                        }}
                    >
                        <Button
                            variant="outlined"
                            onClick={() => confirmParkinglotClick("confirmParkingLot")}
                            className={
                                confirmParkingLot === "confirmParkingLot"
                                    ? classes.buttonActive
                                    : classes.buttonInactive
                            }

                        >
                            Check-in from office parking lot
                        </Button>
                    </Grid>
                    <Grid container
                        style={{ justifyContent: "center", alignContent: "center", display: "flex" }}>
                        <Typography style={{ color: fontColor }}>
                            {parkingLotMessage}
                        </Typography>
                    </Grid>
                    <Grid container spacing={3} className={styles.flexend_Grid}>
                        <Grid item>
                            <Button
                                onClick={handleDone}
                                variant="contained"
                                className={styles.navigationButton}
                                id="done"
                            >
                                Done
                            </Button>
                        </Grid>
                    </Grid>
                </div>)}
                {/* FB 10675 End */}
                <Dialog open={openDialog} disableBackdropClick fullWidth maxWidth={"xs"}>
                    <DialogTitle style={{ display: "flex", alignContent: "center", justifyContent: "center" }}>
                        <Typography style={{ fontWeight: "bold" }} variant="h6">
                            Verification
                        </Typography>
                        <IconButton
                            aria-label="close"
                            onClick={CloseDialog} //FB 4960
                            style={{
                                position: 'absolute',
                                right: 8,
                                top: 8,
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent style={{ display: "flex", alignContent: "center", justifyContent: "center" }}>
                        <OTPModal
                            onCallback={setOpenDialog}
                            patientContact={patientContact}
                            appointment_n={route.decodedApptN}  //EMR-335
                            selectedStep={selectedStep} />
                    </DialogContent>
                    <DialogActions></DialogActions>
                </Dialog>
            </section>
        </div>
    );
};

export default Landingpage;